
import { useEffect, useRef } from "react";
import { Card, CardContent } from "@/components/ui/card";

const testimonials = [
  {
    name: "Sarah",
    location: "3 share property, London NW3",
    content: "Leveraging FlatJive gives us complete transparency across all shareholders which has helped us make decisions quickly."
  },
  {
    name: "Alex",
    location: "4 share property, London N4",
    content: "FlatJive gave us a clear structure to budget and collect service charge, reducing the headache when payments were due."
  },
  {
    name: "Malika",
    location: "4 share property, London W14",
    content: "It's great being able to allocate and track tasks ensuring we share the workload fairly. We saved £2,000 a year moving to self-management."
  }
];

const ModernTestimonials = () => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const elements = entry.target.querySelectorAll(".reveal");
            elements.forEach((el, index) => {
              setTimeout(() => {
                el.classList.add("active");
              }, index * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section
      id="testimonials"
      ref={sectionRef}
      className="py-12 md:py-16 px-4 sm:px-6 lg:px-8 bg-background"
    >
      <div className="container mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="reveal text-3xl md:text-4xl font-bold text-foreground mb-4">
            Consistently positive feedback from existing customers
          </h2>
          <p className="reveal text-lg md:text-xl text-foreground">
            FlatJive is transforming leasehold management across the United Kingdom.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="reveal">
              <Card className="bg-white border-border hover:border-saas-blue transition-all duration-300 h-full">
                <CardContent className="p-6 border-l-4 border-saas-blue h-full flex flex-col">
                  <blockquote className="text-foreground text-lg leading-relaxed mb-2 flex-1">
                    "{testimonial.content}"
                  </blockquote>
                  
                  <div className="text-sm text-foreground">
                    <span className="font-semibold">{testimonial.name}</span>
                    {" "}
                    <span>({testimonial.location})</span>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ModernTestimonials;
